import React from 'react';
import { ProfileSearchSelect } from 'features/profiles/ProfileSearchSelect';
import './PageProfileSearch.css';

interface PageProfileSearchProps {
  selectedProfileId?: string | null;
  onSelectProfile: (profileId: string) => void;
  onClear?: () => void;
  className?: string;
  placeholder?: string;
  defaultMenuOpen?: boolean;
  autoFocus?: boolean;
}

/** Compact profile picker for page headers. */
export const PageProfileSearch: React.FC<PageProfileSearchProps> = ({
  selectedProfileId = null,
  onSelectProfile,
  onClear,
  className,
  placeholder = 'Select Profile',
  defaultMenuOpen,
  autoFocus,
}) => (
  <div className={['page-profile-search', className].filter(Boolean).join(' ')}>
    <ProfileSearchSelect
      selectedProfileId={selectedProfileId}
      onSelectProfile={onSelectProfile}
      onClear={onClear}
      placeholder={placeholder}
      menuPlacement="bottom"
      className="page-profile-search-select"
      defaultMenuOpen={defaultMenuOpen}
      autoFocus={autoFocus}
    />
  </div>
);
